/*!

=========================================================
* Material Dashboard React - v1.9.0
=========================================================

*/
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
// import { Router, Route, Switch, Redirect } from "react-router-dom";

// core components
//import Admin from "layouts/Admin.js";
//import RTL from "layouts/RTL.js";
//import Login from "./Login";

import App from "./routes/App";
import "assets/css/material-dashboard-react.css?v=1.9.0";

const hist = createBrowserHistory();
/*
ReactDOM.render(
  <Router history={hist}>
    <Switch>
      <Route path="/login" component={Login} />
      <Redirect from="/" to="/login" />
    </Switch>
  </Router>,
  document.getElementById("root")
);
*/

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);

